import * as React from "react";

export function HStack(
  props: React.HTMLAttributes<HTMLDivElement>
): React.ReactElement {
  const className = `flex flex-row ${props.className}`;
  return <div {...props} className={className}></div>;
}

export function VStack(
  props: React.HTMLAttributes<HTMLDivElement>
): React.ReactElement {
  const className = `flex flex-col ${props.className}`;
  return <div {...props} className={className}></div>;
}

export function Center(
  props: React.HTMLAttributes<HTMLDivElement>
): React.ReactElement {
  const className = `flex items-center justify-center ${props.className}`;
  return <div {...props} className={className}></div>;
}

export function Box(
  props: React.HTMLAttributes<HTMLDivElement>
): React.ReactElement {
  const className = `${props.className}`;
  return <div {...props} className={className}></div>;
}

export function Error({
  text,
  className,
}: {
  text?: string;
  className?: string;
}) {
  return (
    <p className={`text-[10px] text-red-500 ${className}`}>{text}</p>
  );
}

export const PlatformUrlMapping = {
  investor: process.env.REACT_APP_INVESTOR_URL,
  taskManager: process.env.REACT_APP_TASKMANAGER_URL,
  captable: process.env.REACT_APP_CAPTABLE_URL,
  esop: process.env.REACT_APP_ESOP_URL,
};

export enum PlatformEnum {
  investor = "investor",
  taskManager = "taskManager",
  captable = "captable",
  esop = "esop",
}
